<template>
  <div id="card-stock">
    <vx-card class="overflow-hidden bg-black" slot="no-body">
      <div>
        <p>{{ date }}</p>
      </div>
      <div class="vx-row flex end">
        <p class="mb-1 font-bold">{{ $t('input') }}</p>
        <div class="vx-row items-center">
          <h2 class="m-1 font-bold" :class="themeColor(changing)">
            {{ toLocaleString(value) }}
          </h2>
          <div class="vx-col">
            <p class="mb-1 font-bold" :class="themeColor(changing)">
              {{ `${mathSymbols(changing)}${toLocaleString(changing)}` }}
            </p>
            <p class="mb-1 font-bold" :class="themeColor(changing)">
              {{ `${mathSymbols(changing)}${percent}` }}%
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="vx-row space-around">
        <p>Vol 10,683.52 M</p>
        <p>Val 55,111.41 M</p>
      </div> -->
    </vx-card>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "cardStock",
  props: {
    title: {
      type: String,
      default: "input",
    },
    value: {
      type: Number,
      default: 0,
    },
    lastValue: {
      type: Number,
      default: 0,
    },
    date: {
      type: String,
      default: moment().format("DD/MM/YYYY"),
    },
  },
  data() {
    return {
      percent: "0%",
      changing: 0,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.calcPercent();
      }
    },
  },
  mounted() {
    this.calcPercent();
  },
  methods: {
    calcPercent() {
      this.percent = (
        ((this.value - this.lastValue) / this.lastValue) *
        100
      ).toFixed(2);

      this.changing = (this.value - this.lastValue)
    },
    themeColor(val) {
      let color = "";
      if (val > 0) {
        color = "success";
      } else if (val < 0) {
        color = "danger";
      }
      return color;
    },
    mathSymbols(val) {
      let res = "";
      if (val > 0) {
        return "+";
      }
      return res;
    },
    toLocaleString(val) {
      return val.toLocaleString('en-US');
    },
  },
};
</script>
<style scoped>
.end {
  justify-content: space-around;
  align-items: center;
}
.space-around {
  justify-content: space-around;
}
.space-around p {
  font-weight: 500;
}
.bg-black {
  background-color: black;
  color: white;
}
</style>